import React from 'react';
import { Plus } from 'lucide-react';
import { useLanguage } from '../../contexts/LanguageContext';

interface AddCandidateButtonProps {
  onClick: () => void;
}

const AddCandidateButton = ({ onClick }: AddCandidateButtonProps) => {
  const { t } = useLanguage();
  return (
    <button
      onClick={onClick}
      className="flex items-center gap-2 px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors focus:ring-4 focus:ring-blue-500/50"
    >
      <Plus className="w-4 h-4" />
      <span>{t('candidates.addCandidate')}</span>
    </button>
  );
};

export default AddCandidateButton;